import { __assign, __extends } from "tslib";
/** A standard menu containing a user's gallections generally used as the
 *  target of some action like where to move a deviation or other folder */
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { convertToFoldersWithSubfolders } from '../../../utils/folders';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import withGallections from '../../_hocs/withGallections';
import { areGallectionContentsManageable } from '../../helpers';
import { getAllGallections } from '../../selectors';
import StandardMenu from '../../../Dropdown/MenuPreset/StandardMenu';
import { isPremiumGallection } from '../../../utils/gallections';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import PremiumIcon from '../../../DeviationViews/Thumb/Standard/Overlay/_partials/PremiumIcon';
import gallectionListMenuStyles from './GallectionListMenu.scss';
var enhance = compose(withCurrentGallection, withCurrentSubfolder, withGallections, connectMediaStore(function (state) { return ({
    allGallections: getAllGallections(state),
}); }));
var GallectionListMenu = /** @class */ (function (_super) {
    __extends(GallectionListMenu, _super);
    function GallectionListMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** is a given folder shown in this gallection menu */
        _this.isFolderShown = function (folder) {
            var _a = _this.props, currentFolderId = _a.currentFolderId, currentSubfolderId = _a.currentSubfolderId, _b = _a.excludeFolderIds, excludeFolderIds = _b === void 0 ? [] : _b;
            var currentGallectionId = currentSubfolderId || currentFolderId;
            return (
            // a folder itself is not a target of it's own actions
            folder.folderId !== currentGallectionId &&
                // don't target a non-manageable folder
                areGallectionContentsManageable(folder) &&
                // given disabled folders aren't shown
                !excludeFolderIds.includes(folder.folderId));
        };
        return _this;
    }
    GallectionListMenu.prototype.render = function () {
        var _a = this.props, className = _a.className, onSelect = _a.onSelect;
        return (React.createElement(StandardMenu, { id: "gallection-list-menu", lightText: true, className: classnames(gallectionListMenuStyles['root'], className), items: this.buildDropdownItemsFromFolders(), onSelect: onSelect }));
    };
    /** build an array of dropdown items to be used in the final menu */
    GallectionListMenu.prototype.buildDropdownItemsFromFolders = function () {
        var _this = this;
        var _a = this.props, allGallections = _a.allGallections, onlyTopLevelFolders = _a.onlyTopLevelFolders, _b = _a.disableFolderIds, disableFolderIds = _b === void 0 ? [] : _b, disableReasonHint = _a.disableReasonHint, firstItem = _a.firstItem;
        var menuItems = [];
        var foldersWithSubfolders = convertToFoldersWithSubfolders(allGallections);
        foldersWithSubfolders.forEach(function (folder) {
            var _a, _b;
            var parentFolderShown = _this.isFolderShown(folder);
            var label = folder.name;
            if (isPremiumGallection(folder)) {
                label = (React.createElement(React.Fragment, null,
                    React.createElement(PremiumIcon, { premiumFolderData: folder.premiumFolderData, className: gallectionListMenuStyles['premium-icon'], withTooltip: false }),
                    folder.name));
            }
            var disabled = disableFolderIds.includes(folder.folderId);
            var parentDropdownItem = __assign({ value: folder.folderId, disabled: disabled, label: disabled && disableReasonHint ? (React.createElement(TextTooltipOnHover, { placement: "right", tooltipText: disableReasonHint, renderReference: function (_a) {
                        var ref = _a.ref;
                        return (React.createElement("span", { style: { pointerEvents: 'all' }, ref: ref }, label));
                    } })) : (label) }, (!parentFolderShown && { disabled: true }));
            var subfolderItems = onlyTopLevelFolders
                ? []
                : (_b = (_a = folder.subfolders) === null || _a === void 0 ? void 0 : _a.filter(_this.isFolderShown).map(function (subfolder) { return ({
                    value: subfolder.folderId,
                    disabled: disableFolderIds.includes(subfolder.folderId),
                    label: subfolder.name,
                    className: gallectionListMenuStyles['subfolder'],
                }); })) !== null && _b !== void 0 ? _b : [];
            // note: even if the parent folder shouldn't be shown, it's subfolders might be
            // in that case, show the parent folder as disabled
            if (subfolderItems.length || parentFolderShown) {
                menuItems.push(parentDropdownItem);
            }
            menuItems.push.apply(menuItems, subfolderItems);
        });
        if (firstItem) {
            return [
                { items: [firstItem] },
                { items: menuItems },
            ];
        }
        return menuItems;
    };
    return GallectionListMenu;
}(React.Component));
export default enhance(GallectionListMenu);
//# sourceMappingURL=GallectionListMenu.connected.js.map